import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { mascaraCelular9Digito, formataDataDDMMYYYYParaHTML5, formataDataHTML5ParaDDMMYYYY } from '../../modules/util';
import CONSTANTS from '../../constants';

export default class FormDadosSolicitante extends React.Component {

    componentDidMount() {

    }

    render() {

        return (
            <div>
                <fieldset>
                    <legend>Solicitante</legend>
                    <FormControl className='item-form'
                        style={{
                            textAlign: "center"
                        }}>
                        <TextField
                            type="number"
                            disabled={true}
                            style={{ width: "170px" }}
                            id="pes-cpf"
                            label="CPF"
                            value={this.props.pesCPF > 0 ? this.props.pesCPF : ""}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className='item-form' style={{ width: "40%", minWidth: "320px" }} >
                        <TextField
                            disabled={true}
                            type="text"
                            fullWidth
                            id="pes-nome"
                            label="Nome"
                            value={this.props.pesNome}
                            margin="normal"
                        />
                    </FormControl>
                </fieldset>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/fiadores/form-dados-solicitante.js